import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Titlebar from '../components/Titlebar'
import Navbar from '../components/Navbar'
import ButtonBar from '../components/ButtonBar'

function MainLayout({children, showNavbar = true, showAdminTab = true, showButtonBar = true, showAllButton = true, 
  openNewEntryPopup }) {

  // useEffect, um die jeweils vorherige Seite bei jedem Seitenwechsel im localStorage zu speichern, 
  // wird von ButtonBar Button statisch gebraucht, um die Markierung in der Tabelle zu behalten, 
  // wenn er von Maachinenkonfiguration zurueck kommt
  const location = useLocation();
  const currentPage = location.pathname;

  useEffect(() => {
    // Speichere den aktuellen Pfad als vorherige Seite für den naechsten Seitenwechsel
    window.localStorage.setItem('previousPage', currentPage);
  }, [currentPage]);


  return (
    <div className="page-background">
        <Titlebar></Titlebar>

        {(showNavbar || showAdminTab) && <Navbar showAdminTab={showAdminTab}/>}

        {/* Auswahl, ob alle Buttons oder nur der new-Button von der ButtonBar angezeigt werden*/}
        {(showButtonBar || showAllButton) && <ButtonBar showAllButton={showAllButton} openNewEntryPopup={openNewEntryPopup} />}

        <div>{children}</div>

    </div>
  )
}

export default MainLayout
